<template>
    <div style="background: #f7f7f4; min-height: calc(100vh - 100px); padding: 16px 0;">
        <div style="max-width: 1200px; margin: 0 auto; padding: 0 12px;">
            <div style="font-family: 'CursorGothic', system-ui, 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 11px; font-weight: 600; line-height: 1.4; letter-spacing: 0.88px; text-transform: uppercase; color: #807d72; margin-bottom: 12px;">账户与会员</div>
            <el-row :gutter="16" style="display: flex; flex-wrap: wrap;">
                <el-col :xs="24" :sm="24" :lg="8" style="margin-bottom: 16px; display: flex;">
                    <div style="border: 1px solid #e6e5e0; border-radius: 12px; background: #ffffff; padding: 20px; flex: 1;">
                        <div style="font-size: 16px; font-weight: 600; color: #26251e; padding-bottom: 12px; border-bottom: 1px solid #efeee8; margin-bottom: 16px;">用户信息</div>

                        <div style="margin-bottom: 16px;">
                            <div style="font-size: 12px; color: #807d72; margin-bottom: 4px;">手机号</div>
                            <div style="font-size: 15px; color: #26251e;">{{ phone || '—' }}</div>
                        </div>

                        <div style="margin-bottom: 20px;">
                            <div style="font-size: 12px; color: #807d72; margin-bottom: 4px;">余额</div>
                            <div style="font-size: 24px; font-weight: 400; letter-spacing: -0.3px; color: #26251e; line-height: 1.1;">
                                {{ balance || 0 }}<span style="font-size: 13px; color: #a09c92; margin-left: 4px; font-weight: 400;">元</span>
                            </div>
                        </div>

                        <div style="padding-top: 12px; border-top: 1px solid #efeee8;">
                            <div style="font-size: 12px; color: #807d72; margin-bottom: 4px;">修改密码</div>
                            <div style="font-size: 13px; color: #a09c92;">请前往手机APP修改</div>
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="24" :lg="16" style="margin-bottom: 16px; display: flex;">
                    <div style="border: 1px solid #e6e5e0; border-radius: 12px; background: #ffffff; padding: 20px; flex: 1;">
                        <div style="font-size: 16px; font-weight: 600; color: #26251e; padding-bottom: 12px; border-bottom: 1px solid #efeee8; margin-bottom: 12px;">我的会员</div>
                        <div class="vip-container">
                            <User_vip ref="user_vip"></User_vip>
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="24" :lg="24" style="margin-bottom: 16px;">
                    <div style="border: 1px solid #e6e5e0; border-radius: 12px; background: #ffffff; padding: 20px;">
                        <div style="font-size: 11px; font-weight: 600; letter-spacing: 0.88px; text-transform: uppercase; color: #807d72; margin-bottom: 12px;">充值记录</div>
                        <el-table :data="orderData" stripe style="width: 100%;" size="small"
                            :header-cell-style="{ background: '#f7f7f4', color: '#807d72', fontFamily: 'CursorGothic, system-ui, sans-serif', fontSize: '12px', fontWeight: '500', borderBottom: '1px solid #e6e5e0' }"
                            :cell-style="{ color: '#5a5852', fontFamily: 'CursorGothic, system-ui, sans-serif', fontSize: '13px', borderBottom: '1px solid #efeee8' }">
                            <el-table-column prop="ordernum" label="订单号" />
                            <el-table-column prop="je" label="金额(元)">
                                <template slot-scope="scope">
                                    <span style="font-weight: 500; color: #26251e;">{{ scope.row.je }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="intime" label="日期" :formatter="formatDate" />
                        </el-table>
                        <div v-if="total > 5" style="display: flex; justify-content: center; padding-top: 16px; border-top: 1px solid #efeee8; margin-top: 12px;">
                            <el-pagination small layout="prev, pager, next" :page-size="5" :total="total"
                                @current-change="fy_page" :current-page="page" background />
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import User_vip from './my/user_vip.vue';
export default {
    name: '',
    components: {
        User_vip
    },
    // 定义属性
    data() {


        return {
            phone: '',
            balance: '',
            xgmm: '',
            orderData: [],
            page: 1,
            total: 0
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        formatDate(row) {
            let date = new Date(row['intime'] * 1000);
            // console.log(date);
            // console.log(row);
            // console.log(row['intime']);
            let Y = date.getFullYear() + '-';
            let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-';
            let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
            let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
            let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
            let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
            return Y + M + D + h + m + s;
        },
        info(type = '') {
            if (type != '') {
                // 修改密码逻辑（暂时跳过）
                this.$msg.warning('请前往手机APP修改密码')
                return
            }
            // 使用新后端接口获取用户信息
            this.$ajax.get('api/v1/users/me').then(res => {
                if (res.data) {
                    this.phone = res.data.phone
                    this.balance = res.data.balance
                }
            }).catch(err => {
                console.error(err)
                this.$msg.error('获取用户信息失败')
            })
        },
        fy_page(e) {
            this.page = e
            this.order()
        },
        order() {

            this.$ajax.post('qhy/user/user_order?page=' + this.page, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                var jg = res.data
                if (res.data.status == 200) {

                    this.orderData = jg.order.data
                    this.total = jg.order.total

                } else {
                    this.$msg.error(res.data.msg)
                }

            })
        }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.info()
        this.order()

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.$refs.user_vip.get_vip_list()
    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.vip-container {
    max-height: 240px;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #e6e5e0 transparent;
}

.vip-container::-webkit-scrollbar {
    width: 4px;
}

.vip-container::-webkit-scrollbar-thumb {
    background: #e6e5e0;
    border-radius: 2px;
}

/* el-pagination background variant override */
.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #26251e;
}

@media (max-width: 768px) {
    .vip-container {
        max-height: 320px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/User/Info.vue


// WEBPACK FOOTER //
// src/components/User/Info.vue